import { Action } from '@ngrx/store';

export const REQUEST_MEMO_STATISTICS = '[Request][Statistics] memo stats';
export const RESPONSE_SUCCESS_MEMO_STATISTICS = '[Response][Success][Statistics] memo stats';
export const RESPONSE_FAIL_MEMO_STATISTICS = '[Response][Fail][Statistics] memo stats';

export const REQUEST_MEMBERS_STATISTICS = '[Request][Statistics] members stats';
export const RESPONSE_SUCCESS_MEMBERS_STATISTICS = '[Response][Success][Statistics] members stats';
export const RESPONSE_FAIL_MEMBERS_STATISTICS = '[Response][Fail][Statistics] members stats';

export const REQUEST_CUSTOMERS_STATISTICS = '[Request][Statistics] customers stats';
export const RESPONSE_SUCCESS_CUSTOMERS_STATISTICS =
  '[Response][Success][Statistics] customers stats';
export const RESPONSE_FAIL_CUSTOMERS_STATISTICS = '[Response][Fail][Statistics] customers stats';

export class RequestMemoStatisticsAction implements Action {
  readonly type = REQUEST_MEMO_STATISTICS;
}

export class ResponseSuccessMemoStatisticsAction implements Action {
  readonly type = RESPONSE_SUCCESS_MEMO_STATISTICS;
  constructor(public payload: any) {}
}

export class ResponseFailMemoStatisticsAction implements Action {
  readonly type = RESPONSE_FAIL_MEMO_STATISTICS;
  constructor(public payload: any) {}
}

export class RequestMembersStatisticsAction implements Action {
  readonly type = REQUEST_MEMBERS_STATISTICS;
  constructor(public payload?: { limit: number }) {}
}

export class ResponseSuccessMembersStatisticsAction implements Action {
  readonly type = RESPONSE_SUCCESS_MEMBERS_STATISTICS;
  constructor(public payload: any) {}
}

export class ResponseFailMembersStatisticsAction implements Action {
  readonly type = RESPONSE_FAIL_MEMBERS_STATISTICS;
  constructor(public payload: any) {}
}

export class RequestCustomersStatisticsAction implements Action {
  readonly type = REQUEST_CUSTOMERS_STATISTICS;
  constructor(public payload?: { limit: number }) {}
}

export class ResponseSuccessCustomersStatisticsAction implements Action {
  readonly type = RESPONSE_SUCCESS_CUSTOMERS_STATISTICS;
  constructor(public payload: any) {}
}

export class ResponseFailCustomersStatisticsAction implements Action {
  readonly type = RESPONSE_FAIL_CUSTOMERS_STATISTICS;
  constructor(public payload: any) {}
}
